import { CustomerName } from "@lib/components/MiniComponents/Others";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { walletTypeColor } from "@lib/helpers/ColorHelper";
import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import { PaginationType, UseQueryProps } from "@lib/types/Api";
import { Wallet } from "@lib/types/Billing";
import { SendByteWallet } from "@lib/types/SendByte";
import { Form, Select, Tag, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { useMemo } from "react";
import { useIntl } from "react-intl";

type Props = {
  walletsQuery: UseQueryProps<PaginationType<Wallet | SendByteWallet>>;
  form: FormInstance<any>;
  loading?: boolean;
};

export default function WalletIdInput(props: Props) {
  const { walletsQuery, loading, form } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);

  const walletsData = useMemo(() => {
    return walletsQuery.data?.data?.data || [];
  }, [
    walletsQuery.data?.data,
    walletsQuery.isLoading,
    walletsQuery.isFetching,
  ]);

  return (
    <Form.Item
      shouldUpdate
      name="walletId"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.wallet"] as string}
      hasFeedback
      validateStatus={walletId ? "success" : "warning"}
      extra={
        walletId ? null : (messages["common.pleaseFirstSelectWallet"] as string)
      }
    >
      <Select
        allowClear
        placeholder={messages["common.makeYourChoice"] as string}
        onChange={(value) => {
          form.setFieldValue("walletId", value);
        }}
        loading={walletsQuery.isLoading || walletsQuery.isFetching}
        disabled={loading || walletsQuery.isLoading || walletsQuery.isFetching}
        showSearch
        optionFilterProp="text"
        options={walletsData?.map((wallet) => ({
          label: (
            <small>
              <StyledFlex style={{ gap: 5 }}>
                <Typography>{wallet.name}</Typography>
                <Typography>|</Typography>
                <Tag
                  style={{ lineHeight: "15px" }}
                  color={walletTypeColor(wallet.type)}
                >
                  {messages["walletType"][wallet.type] as string}
                </Tag>
                {"customer" in wallet && wallet.customer && (
                  <>
                    <Typography>|</Typography>
                    <CustomerName customer={wallet.customer} size="small" />
                  </>
                )}
              </StyledFlex>
            </small>
          ),
          text: wallet.name,
          value: wallet.id,
        }))}
      />
    </Form.Item>
  );
}
